import { selector } from "recoil";
import {
  CompanyState,
  loggedInUserState,
  metaDataState,
  targetCompletionAnimationState
} from "./atom";
import { toLower, get as _get, camelCase } from "lodash";
import {
  DELETE_ACCESS,
  MODIFY_ACCESS,
  READ_ACCESS,
  WRITE_ACCESS
} from "../../constants/literalConstant";

export const loggedInUserDetails = selector({
  key: "filteredTodoListState",
  get: ({ get }) => {
    return get(loggedInUserState);
  }
});

export const CompanyDetails = selector({
  key: "companyDetailState",
  get: ({ get }) => {
    return get(CompanyState);
  }
});

export const targetCompletionAnimation = selector({
  key: "targetCompletionAnimationState",
  get: ({ get }) => {
    return get(targetCompletionAnimationState);
  },
  set: ({ set }, booleanValue) => {
    set(targetCompletionAnimationState, booleanValue);
  }
});

export const metaDataDetails = selector({
  key: "MetaDatDetailsaState",
  get: ({ get }) => {
    const metaData = get(metaDataState);
    if (metaData && metaData.length) {
      const distinctMetaType = [...new Set(metaData.map(x => x.metaType))];
      let setObject = {};
      distinctMetaType.forEach(data => {
        const filteredData = metaData.filter(res => res.metaType === data);
        setObject = { ...setObject, [toLower(data)]: filteredData };
      });
      return setObject;
    }
    return {};
  }
});

export const permissionsSet = selector({
  key: "getPermissionSer",
  get: ({ get }) => {
    const data = get(loggedInUserState);
    const additionalData = _get(data, "additionalPermission", "");
    const defaultData = _get(data, "defaultPermission", "");
    const roleDetail =
      additionalData && additionalData.name ? additionalData : defaultData;
    let permissions = {};
    if (_get(roleDetail, "name", "")) {
      for (let key in roleDetail) {
        if (Array.isArray(roleDetail[key])) {
          roleDetail[key].map(permission => {
            _get(permission, "permission", []).map(modulePermission => {
              const code = camelCase(modulePermission.code, "_");
              permissions[code] = {
                deleteAccess: _get(modulePermission, DELETE_ACCESS, false),
                modifyAccess: _get(modulePermission, MODIFY_ACCESS, false),
                readAccess: _get(modulePermission, READ_ACCESS, false),
                writeAccess: _get(modulePermission, WRITE_ACCESS, false)
              };
              return modulePermission;
            });
            return permission;
          });
        }
      }
      return permissions;
    }
  }
});
